<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>الموظفين</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض جميع الموظفين
              <div v-show="$per.value.saveEmployee" class='pull-left' style='padding=0px'>
                <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                  <b>  إضافة جديد </b>
                </button>
              </div>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='form-group col-lg-6 col-sm-6'>
                <span>الفرع:</span>
                <select @change='GetData($event.target.value)' class="form-control" style="padding: 0px" v-model="branch">
                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-3 col-md-3 col-sm-6'>
                  <span>العرض</span>
                  <select style="padding: 0px" class="form-control"  v-model="displayTypeID" >
                    <option v-for="item in displayType" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
              </div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>م</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الاسم</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>المحمول</th>
                    <th colspan=5 style='vertical-align: middle;padding:2px;text-align: center'>الصلاحيات</th>
                    <th rowspan=2 style='vertical-align: middle;padding:2px;text-align: center'>الاجراء</th>
                  </tr>
                  <tr>
                    <th style='width:40px;text-align: center'><img :src="getImgUrl('01')" style="width:24px;height:24px;"></th>
                    <th style='width:40px;text-align: center'><img :src="getImgUrl('05')" style="width:24px;height:24px;"></th>
                    <th style='width:40px;text-align: center'><img :src="getImgUrl('03')" style="width:24px;height:24px;"></th>
                    <th style='width:40px;text-align: center'><img :src="getImgUrl('04')" style="width:24px;height:24px;"></th>
                    <th style='width:40px;text-align: center'><img :src="getImgUrl('02')" style="width:24px;height:24px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='(record, index) in filteredRecords' :key='record.id'>
                    <td align='center'>{{index+1}}</td>
                    <td style='vertical-align: middle;padding:4px;text-align: right'><img :src="imgURL + record.av_img" class="avatar"> {{record.name}}</td>
                    <td align='center'>{{record.mobile}}</td>
                    <td align='center' :class="{itemColor:record.site_auth}"></td>
                    <td align='center' :class="{itemColor:record.mob_browser}"></td>
                    <td align='center' :class="{itemColor:record.static_ip}"></td>
                    <td align='center' :class="{itemColor:record.admin}"></td>
                    <td align='center' :class="{itemColor:record.mob_auth}"></td>
                    <td align='center'>
                      <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                      <button v-show="$per.value.deleteEmployee" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                      <button v-show="$per.value.editEmployee" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                  <div class="panel panel-default">
                      <div class="panel-body">
                          <!-- Nav tabs -->
                          <ul class="nav nav-tabs">
                              <li class="active"><a href="#home" data-toggle="tab">بيانات الموظف</a>
                              </li>
                              <li><a href="#profile" data-toggle="tab">الصلاحيات والاشعارات</a>
                              </li>
                          </ul>

                          <!-- Tab panes -->
                          <div class="tab-content">
                              <div class="tab-pane fade in active" id="home" style = "padding-top: 15px">
                                  <div class='form-group col-lg-4 col-sm-4'>
                                  <label>الفرع:</label>
                                  <select @change="UpdateData(record.branche_id)" class="form-control" style="padding: 0px" v-model="record.branche_id">
                                    <option v-for="branch in mainBranches" v-bind:key="branch.id" v-bind:value="branch.id">
                                      {{ branch.name }}
                                    </option>
                                  </select>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>المجموعة:</label>
                                  <select class="form-control" style="padding: 0px" v-model="record.permission_id">
                                    <option v-for="Group in empGroups" v-bind:key="Group.id" v-bind:value="Group.name">
                                      {{ Group.display_name }}
                                    </option>
                                  </select>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>الوظيفة:</label>
                                  <select class="form-control" style="padding: 0px" v-model="record.Job_id">
                                    <option v-for="Jop in empJops" v-bind:key="Jop.id" v-bind:value="Jop.id">
                                      {{ Jop.name }}
                                    </option>
                                  </select>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>الاسم:</label>
                                  <input v-model='record.name' class='form-control' name='name' type='text'>
                                </div>
                                <div class='form-group col-lg-8 col-sm-8'>
                                  <label>العنوان:</label>
                                  <input v-model='record.address' class='form-control' name='address' type='text'>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>البريد الالكترونى:</label>
                                  <input v-model='record.email' class='form-control' name='email' type='text'>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>التليفون:</label>
                                  <input v-model='record.phone' class='form-control' name='phone' type='text'>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>المحمول:</label>
                                  <input v-model='record.mobile' class='form-control' name='mobile' type='text'>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>الراتب:</label>
                                  <input v-model='record.salary' class='form-control' name='salary' type='text'>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>اسم المستخدم:</label>
                                  <input v-model='record.username' class='form-control' name='username' type='text'>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>النوع فى كشف الرواتب:</label>
                                  <select class="form-control" style="padding: 0px" v-model="record.show_salary">
                                    <option v-for="item in salary_show" v-bind:key="item.id" v-bind:value="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>حالة الحساب:</label>
                                  <select class="form-control" style="padding: 0px" v-model="record.status">
                                    <option v-for="item in status" v-bind:key="item.id" v-bind:value="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </div>
                                <!-- <div class='form-group col-lg-4 col-md-6 col-sm-4'>
                                    <label>الخزنة:</label>
                                    <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
                                      <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                                        {{ treasury.name }}
                                      </option>
                                    </select>
                                </div>
                                <div class='form-group col-lg-4 col-md-6 col-sm-4' >
                                    <label>المخزن:</label>
                                    <select class="form-control" style="padding: 0px" v-model="record.store_id">
                                      <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                                        {{ store.name }}
                                      </option>
                                    </select>
                                </div> -->
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>النسبة كمفوض % :</label>
                                  <input @keypress="isNumber($event)" v-model='record.del_commission' class='form-control' name='username' type='text'>
                                </div>
                                <div class='form-group col-lg-4 col-sm-4'>
                                  <label>الوظائف:</label>
                                  <br>
                                  <label style="padding-right:15px;margin-top:5px" class="checkbox-inline">
                                    <input  v-model='record.technical' style="margin-right:-15px" type="checkbox">فنى
                                  </label>
                                  <label style="padding-right:10px;margin-top:5px" class="checkbox-inline">
                                    <input  v-model='record.collector' style="margin-right:-15px" type="checkbox">محصل
                                  </label>
                                  <label style="padding-right:10px;margin-top:5px" class="checkbox-inline">
                                    <input  v-model='record.delegate' style="margin-right:-15px" type="checkbox">مفوض/مندوب
                                  </label>
                                  <!-- <div class='form-group col-lg-6 col-md-6 col-sm-6' >
                                    <vue-element-loading size='32' :active='isSaveStore' spinner='spinner' color='#A4A4A4'/>
                                    <button :disabled="record.store_id" @click="saveStore()" type="button" class="btn btn-warning">إنشاء مخزن</button>
                                  </div> -->
                                  <!-- <div class='form-group col-lg-6 col-md-6 col-sm-6'>
                                    <vue-element-loading size='32' :active='isSaveTreasury' spinner='spinner' color='#A4A4A4'/>
                                    <button :disabled="record.treasury_id" @click="saveTreasury()" type="button" class="btn btn-warning">إنشاء خزنة</button>
                                  </div> -->
                                </div>
                              </div>
                              <div class="tab-pane fade" id="profile" style = "padding-top: 15px">
                                  <div v-show="isAdmin == 1 " class='form-group col-lg-4 col-md-4 col-sm-4'>
                                    <div class="chat-panel panel panel-default" >
                                        <div class="panel-heading">
                                           صلاحية الفروع
                                        </div>
                                        <!-- /.panel-heading -->
                                        <div class="panel-body" style="padding: 5px">
                                          <div v-for="(item,index) in mainBranches" v-bind:key="index" >
                                            <input  :id="index" type="checkbox" :value="item.id" v-model="record.selectedBranch">{{' ' + item.name }}
                                          </div>
                                        </div>
                                        <!-- /.panel-body -->
                                        <div v-show="record.id === -2" class="panel-footer" style="padding: 8px">
                                          <button v-show="$per.value.editEmployee" @click='resetPws(record.id)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>إعادة تعيين كلمة المرور</button>
                                        </div>
                                    </div>
                                  </div>
                                  <div v-show="isAdmin == 1 " class='form-group col-lg-4 col-md-4 col-sm-4'>
                                    <div class="chat-panel panel panel-default" >
                                        <div class="panel-heading">
                                          الصلاحيات
                                        </div>
                                        <!-- /.panel-heading -->
                                        <div class="panel-body" style="padding: 5px">
                                          <div>
                                            <input  v-model='record.mob_auth'  type="checkbox">{{' التطبيق'}}
                                          </div>
                                          <div>
                                            <input  v-model='record.site_auth' type="checkbox">{{' الموقع'}}
                                          </div>
                                          <div>
                                            <input  v-model='record.static_ip' type="checkbox">{{' ربط الـIP'}}
                                          </div>
                                          <div>
                                            <input  v-model='record.admin' type="checkbox">{{' مدير النظام'}}
                                          </div>
                                          <div>
                                            <input  v-model='record.mob_browser' type="checkbox">{{' الدخول للموقع من المحمول'}}
                                          </div>
                                          <div>
                                            <input  v-model='record.time_limit' type="checkbox">{{' السماح بالدخول فى وقت معين'}}
                                          </div>
                                        </div>
                                        <!-- /.panel-body -->
                                        <div v-show="record.id === -2" class="panel-footer" style="padding: 8px">
                                          <button v-show="$per.value.editEmployee" @click='resetPws(record.id)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>إعادة تعيين كلمة المرور</button>
                                        </div>
                                    </div>
                                  </div>
                                  <div v-show="isAdmin == 1 " class='form-group col-lg-4 col-md-4 col-sm-4'>
                                    <div class="chat-panel panel panel-default" >
                                        <div class="panel-heading">
                                           مجموعات الاشعارات
                                        </div>
                                        <!-- /.panel-heading -->
                                        <div class="panel-body" style="padding: 5px">
                                          <div v-for="channel in channels" :key="channel.key">
                                            <label>
                                              <input
                                                type="checkbox"
                                                :value="channel.key"
                                                v-model="record.notification_channels"
                                              />
                                              {{ channel.label }}
                                            </label>
                                            <!-- <input  v-model='record.mob_auth'  type="checkbox">{{' تأجيل ايصال فى الاصدار'}} -->
                                          </div>
                                        </div>
                                        <!-- /.panel-body -->
                                        <div v-show="record.id === -2" class="panel-footer" style="padding: 8px">
                                          <button v-show="$per.value.editEmployee" @click='resetPws(record.id)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>إعادة تعيين كلمة المرور</button>
                                        </div>
                                    </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <!-- /.panel-body -->
                  </div>
                  <!-- /.panel -->
              </fieldset>
            </div>
            <div class='modal-footer'>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.itemColor {
  background-color: purple !important;
}
</style>
<script>
import axios from 'axios'
export default {
  name: 'employee',
  data () {
    return {
      imgURL: 'https://plfilters.com/api/system/storage/app/av-img/',
      displayType: [{id: -1, name: 'الكل'}, {id: 1, name: 'نشط'}, {id: 0, name: 'غير نشط'}],
      displayTypeID: -1,
      validationErrors: '',
      records: {},
      record: {},
      isSaveStore: false,
      isSaveTreasury: false,
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      treasuries: {},
      stores: {},
      branches: {},
      branch: 0,
      status: [{id: 1, name: 'نشط'}, {id: 0, name: 'غير نشط'}],
      salary_show: [{id: 0, name: 'غير مصنف'}, {id: 1, name: 'فنى'}, {id: 2, name: 'مبيعات'}, {id: 3, name: 'مفوض'}],
      channels: [
        { key: 'delay-receipt', label: 'تأجيل ايصال فى الاصدار' },
        { key: 'all', label: 'افتراضية' }
      ],
      mainBranches: [],
      empGroups: {},
      empJops: {},
      title: '',
      isAdmin: 0,
      isDisabled: true
    }
  },
  computed: {
    filteredRecords () {
      if (this.records) {
        if (this.displayTypeID > -1) {
          return this.records.filter(item => parseInt(item.status) === this.displayTypeID)
        } else {
          return this.records
        }
      }
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch = localStorage.getItem('BrancheID')
    this.mainBranches = JSON.parse(localStorage.getItem('Branches'))
    this.isAdmin = JSON.parse(localStorage.getItem('typeID'))
    this.GetEmpGroups()
    this.GetEmpJops()
    this.GetData(this.branch)
  },
  methods: {
    getImgUrl (pet) {
      var images = require.context('@/assets/', false, /\.png$/)
      return images('./' + pet + '.png')
    },
    // ===========================================
    UpdateData (id) {
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
        this.stores = this.branches[i].stores
      }
      if (!this.record.selectedBranch.includes(id)) {
        this.record.selectedBranch.push(id)
      }
    },
    // ===========================================
    GetEmpGroups () {
      axios.post(this.$apiURL + 'getEmpGroups', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.empGroups = data
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
        })
    },
    // ===========================================
    GetEmpJops () {
      axios.post(this.$apiURL + 'getEmpJops', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.empJops = data
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
        })
    },
    // ===========================================
    resetPws (id) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'reset-password', {
        token: localStorage.getItem('token'),
        id: id
      })
        .then(({ data }) => {
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // ===========================================
    GetData (branchID) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getEmployee', {
        token: localStorage.getItem('token'),
        brancheID: branchID
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          // this.UpdateData(branchID)
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    // ===========================================
    showForm (recID) {
      this.isSaveStore = false
      this.isSaveTreasury = false
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {
          'id': 0,
          'Job_id': '',
          'permission_id': '',
          'branche_id': '',
          'name': '',
          'address': '',
          'phone': '',
          'mobile': '',
          'email': '',
          'salary': '',
          'site_auth': '',
          'username': '',
          'technical': '',
          'collector': '',
          'delegate': '',
          'admin': '',
          'status': 1,
          'show_salary': 0,
          'mob_auth': '',
          'store_id': '',
          'treasury_id': '',
          'static_ip': 0,
          'mob_browser': 0,
          'selectedBranch': [],
          'time_limit': 0,
          'del_commission': 0,
          'notification_channels': []
        }
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
        if (this.record.selectedBranch) {
          if (!Array.isArray(this.record.selectedBranch)) {
            this.record.selectedBranch = this.record.selectedBranch.replace('[', '')
            this.record.selectedBranch = this.record.selectedBranch.replace(']', '')
            this.record.selectedBranch = this.record.selectedBranch.split(',').map(i => Number(i))
          }
        } else {
          this.record.selectedBranch = []
          this.record.selectedBranch.push(this.branch)
        }
        // ----------------------------------------------------------------
        if (!this.record.notification_channels) {
          this.record.notification_channels = []
        } else if (typeof this.record.notification_channels === 'string') {
          try {
            this.record.notification_channels = JSON.parse(this.record.notification_channels)
          } catch (e) {
            this.record.notification_channels = []
          }
        }
      }
    },
    // ====================================================
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveEmployee', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        Job_id: this.record.Job_id,
        permission_id: this.record.permission_id,
        branche_id: this.record.branche_id,
        name: this.record.name,
        address: this.record.address,
        phone: this.record.phone,
        mobile: this.record.mobile,
        email: this.record.email,
        salary: this.record.salary,
        site_auth: this.record.site_auth,
        mob_auth: this.record.mob_auth,
        username: this.record.username,
        technical: this.record.technical,
        collector: this.record.collector,
        delegate: this.record.delegate,
        notification_channels: this.record.notification_channels,
        empIitineraries: this.record.itineraries,
        treasuries: this.record.treasuries,
        stores: this.record.stores,
        status: this.record.status,
        show_salary: this.record.show_salary,
        admin: this.record.admin,
        static_ip: this.record.static_ip,
        selectedBranch: this.record.selectedBranch,
        mob_browser: this.record.mob_browser,
        del_commission: this.record.del_commission,
        time_limit: this.record.time_limit
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.record = res.data
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    // ====================================================
    saveStore () {
      this.isSaveStore = true
      axios.post(this.$apiURL + 'saveStore', {
        token: localStorage.getItem('token'),
        id: 0,
        branche_id: this.record.branche_id,
        name: 'مخزن ' + this.record.name,
        user_id: this.record.id
      })
        .then(res => {
          this.record.store_id = res.data.id
          this.isSaveStore = false
        })
    },
    // ====================================================
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // ====================================================
    saveTreasury () {
      this.isSaveTreasury = true
      axios.post(this.$apiURL + 'saveTreasury', {
        token: localStorage.getItem('token'),
        id: 0,
        branche_id: this.record.branche_id,
        name: 'خزنة ' + this.record.name,
        user_id: this.record.id
      })
        .then(res => {
          this.record.treasury_id = res.data.id
          this.isSaveTreasury = false
        })
    },
    // ====================================================
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteEmployee', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.message === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/Employees.vue